export enum PARTNER_BANNER_OPTIONS {
  GRIDDYNAMICS = 'griddynamics',
  AWS = 'aws',
  GCP = 'gcp',
  COMMERCETOOLS = 'commercetools',
  ALGOLIA = 'algolia',
  MXP = 'mxp',
  CONTENTSTACK = 'contentstack',
  CLOUDINARY = 'cloudinary',
  FLUENTCOMMERCE = 'fluentcomeerce',
  MAGELLAN = 'magellan',
  KIBO = 'kibo',
}

/**
 * Read env variable, split by ','.
 * if no configuration provided returns empty array
 */
const partnerBannerConfiguration = (
  process.env.NEXT_PUBLIC_PARTNER_BANNER || ''
)
  .split(',')
  .reduce(
    (config, p) => (p ? [ ...config, p.trim() ] : config),
    [],
  ) as PARTNER_BANNER_OPTIONS[];

/**
 * PARTNER BANNER CONFIGURATION VALIDATION
 * IF provided configuration for partners is not supported, throws an error
 */
partnerBannerConfiguration.forEach(partner => {
  if (!Object.values(PARTNER_BANNER_OPTIONS).includes(partner)) {
    throw new Error(`
        Invalid environment configuration for Partner Banner: Expected one of: ${Object.values(PARTNER_BANNER_OPTIONS)}. Received: ${partner}. 
        Re-build is required to apply new configuration.
        `);
  }
});

export const PARTNERS: PARTNER_BANNER_OPTIONS[] = partnerBannerConfiguration;
